import { mergeStyleSets } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ResultsScore } from "../../components/ResultsScore";
import { Links } from "../../components/navigation/Links";
import { HSpace, NavigationBar } from "../../components/styled";
import { useSelector } from "../../store/hooks";
import { setSearchInsurersPage } from "../../store/insurersPage";
import { AppDispatch } from "../../store/store";
import { NavigationSearch } from "./NavigationSearch";
import useFilteredInsurerList from "./useFilteredInsurerList";

export const Navigation = () => {
  const { t } = useTranslation();
  const search = useSelector((s) => s.insurersPage.search);
  const dispatch: AppDispatch = useDispatch();

  const insurers = useFilteredInsurerList();

  const classes = getClassNames();
  return (
    <NavigationBar>
      <Links />
      <HSpace />
      <NavigationSearch
        value={search}
        onChange={(value) => {
          dispatch(setSearchInsurersPage(value));
        }}
        placeholder={t("bfm.searchInsurers")}
      />

      <span className={classes.resultScoreContainer}>
        <ResultsScore score={insurers?.length} />
      </span>
    </NavigationBar>
  );
};

const getClassNames = () =>
  mergeStyleSets({
    resultScoreContainer: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end",
    },
    addInsurerBtn: {
      height: "100%",
      i: {
        marginRight: 0,
      },
    },
    addInsurerLink: {
      height: "100%",
    },
  });
